import { useNavigate } from "react-router-dom";

export default function AnalyzerCTA() {
  const navigate = useNavigate();

  return (
    <section className="w-full bg-background-100 py-16 md:py-20">
      <div className="px-6 md:px-12 lg:px-20 max-w-[800px] mx-auto">
        <div className="bg-foreground-950 rounded-2xl p-8 md:p-12 text-center relative overflow-hidden">
          {/* Glow */}
          <div className="absolute -right-20 -top-20 w-60 h-60 rounded-full bg-primary-500/10 blur-3xl pointer-events-none" />
          <div className="relative z-10">
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/15 mx-auto mb-5">
              <i className="ri-bar-chart-box-line text-2xl text-primary-400" />
            </div>

            <span className="text-[11px] font-semibold tracking-[0.25em] uppercase text-primary-400 mb-3 block">
              Bezpłatna analiza
            </span>

            <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3">
              Sprawdź swoją kondycję finansową
            </h2>

            <p className="text-sm text-white/60 leading-relaxed max-w-[480px] mx-auto mb-8">
              Odpowiedz na 6 krótkich pytań w 60 sekund. Bez podawania danych, bez zobowiązań.
              Otrzymasz natychmiastowy wynik i wskazówki, które obszary warto omówić z doradcą.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                onClick={() => navigate("/analiza")}
                className="inline-flex items-center justify-center gap-2.5 px-8 py-3.5 bg-primary-500 text-white font-semibold rounded-full hover:bg-primary-600 hover:scale-105 active:scale-95 transition-all duration-300 shadow-lg shadow-primary-500/20 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-line" />
                Rozpocznij analizę
              </button>
              <a
                href="tel:698084044"
                className="inline-flex items-center justify-center gap-2.5 px-8 py-3.5 border-2 border-white/20 text-white font-semibold rounded-full hover:bg-white/10 hover:border-white/40 hover:scale-105 active:scale-95 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line" />
                Zadzwoń i umów konsultację
              </a>
            </div>

            <div className="flex flex-wrap gap-5 justify-center mt-7">
              {["100% anonimowo", "Wynik natychmiast", "Bez zobowiązań"].map((t) => (
                <span key={t} className="flex items-center gap-2 text-xs text-white/50">
                  <i className="ri-check-line text-green-400" />
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}